import { render, staticRenderFns } from "./priceAdd.vue?vue&type=template&id=0cd3cd92&scoped=true"
import script from "./priceAdd.vue?vue&type=script&lang=js"
export * from "./priceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3cd92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd3cd92')) {
      api.createRecord('0cd3cd92', component.options)
    } else {
      api.reload('0cd3cd92', component.options)
    }
    module.hot.accept("./priceAdd.vue?vue&type=template&id=0cd3cd92&scoped=true", function () {
      api.rerender('0cd3cd92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mediaManage/mediaContentManage/editDialog_componts/priceAdd.vue"
export default component.exports